/* eslint-disable max-len */

import * as R from 'ramda';
import angular from 'angular';

const library = require('@safe-systems/ss-ui-components');

const { copy } = library;

export default function EditMaturityProfileDialogController(
  $filter,
  $q,
  $rootScope,
  $scope,

  alerts,
  confirmCompleteAssessmentDialog,
  ecatDataService,
  ecatSharedModelService,
  loaderService,

  ssDialogService
) {
  const vm = this;

  vm.activeTemplate = ecatSharedModelService.getActiveTemplate(ecatSharedModelService.templates);

  vm.activeDomain = vm.activeTemplate.maturityProfiles[0].maturityDomains[0];
  vm.activeContributionComponent = vm.activeDomain.assessmentFactors[0].contributionComponents[0];
  vm.activeComponentLevel = vm.activeContributionComponent.componentLevels[0];

  vm.handleCloseDialog = handleCloseDialog;
  vm.handleNavToDomain = handleNavToDomain;

  vm.handleExpandContributionComponent = handleExpandContributionComponent;

  vm.handleLevelControlSelectionChange = handleLevelControlSelectionChange;
  vm.handleContributionComponentStatusPill = handleContributionComponentStatusPill;
  vm.handleEditMaturityPropileFormSubmit = handleEditMaturityPropileFormSubmit;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    loaderService.showViewLoader = false;
    return _setInputs().then(() => {
      loaderService.showViewLoader = false;
    });
  }

  /** ***************************************
   * Event Functions
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleNavToDomain(maturityDomainId) {
    const newActiveDomain = $filter('filter')(
      ecatSharedModelService.getActiveTemplate(
        ecatSharedModelService.templates
      ).maturityProfiles[0].maturityDomains,
      { maturityDomainId }
    )[0];
    vm.activeDomain = newActiveDomain;
    angular.element('.ecat--perform-assessment-domains-pane')[0].scrollTop = 0;
  }

  function handleExpandContributionComponent(contributionComponent) {
    if (vm.activeContributionComponent !== contributionComponent) {
      vm.activeContributionComponent = contributionComponent;
      vm.activeComponentLevel = contributionComponent.componentLevels[0];
    } else {
      vm.activeContributionComponent = null;
      vm.activeComponentLevel = null;
    }
  }

  function handleContributionComponentStatusPill(contributionComponent, componentLevel) {
    vm.activeContributionComponent = contributionComponent;
    vm.activeComponentLevel = componentLevel;
  }

  function handleLevelControlSelectionChange(componentLevel) {
    _recalculateLevelControlCounts(componentLevel);
  }

  function handleEditMaturityPropileFormSubmit() {
    loaderService.showViewLoader = true;
    $rootScope.$broadcast('clearECATMaturityProfile', { assessmentId: vm.assessmentId });
    _performSave().then(
      () => {
        alerts.success(copy.advisory.ecat.alerts.saveAssessmentProgressSuccessful.text);
      },
      () => {
        alerts.error(copy.advisory.ecat.alerts.saveAssessmentProgressError.text);
      }
    ).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  /** ***************************************
   * Private Functions
   */

  function _setInputs() {
    const dfdSetInputs = $q.defer();
    const dfdSetLevelControls = $q.defer();

    R.forEach((maturityDomain, maturityDomainIndex) => {
      R.forEach((assessmentFactor, assessmentFactorIndex) => {
        R.forEach((contributionComponent, contributionComponentIndex) => {
          R.forEach((componentLevel, componentLevelIndex) => {
            const templateMaturityDomain = $filter('filter')(
              vm.activeTemplate.maturityProfiles[0].maturityDomains,
              { maturityDomainId: maturityDomain.maturityDomainId }
            )[0];
            const templateAssessmentFactor = $filter('filter')(
              templateMaturityDomain.assessmentFactors,
              { assessmentFactorId: assessmentFactor.assessmentFactorId }
            )[0];
            const templateContributionComponent = $filter('filter')(
              templateAssessmentFactor.contributionComponents,
              { contributionComponentId: contributionComponent.contributionComponentId }
            )[0];
            const templateComponentLevel = $filter('filter')(
              templateContributionComponent.componentLevels,
              { componentLevelId: componentLevel.componentLevelId }
            )[0];
            templateComponentLevel.selectedLevelControlsCount = 0;
            templateComponentLevel.note = componentLevel.note; // Store note
            R.forEach((levelControl, levelControlIndex) => {
              if (levelControl.selected) {
                const templateLevelControl = $filter('filter')(
                  templateComponentLevel.levelControls,
                  { levelControlId: levelControl.levelControlId }
                )[0];
                templateLevelControl.isSelected = true;
                templateComponentLevel.selectedLevelControlsCount += 1;
              }
              if (
                (maturityDomainIndex === (vm.maturityProfile.maturityDomains.length - 1))
                          && (assessmentFactorIndex === (maturityDomain.assessmentFactors.length - 1))
                          && (contributionComponentIndex === (assessmentFactor.contributionComponents.length - 1))
                          && (componentLevelIndex === (contributionComponent.componentLevels.length - 1))
                          && (levelControlIndex === (componentLevel.levelControls.length - 1))
              ) {
                dfdSetLevelControls.resolve();
              }
            },
            componentLevel.levelControls);
          },
          contributionComponent.componentLevels);
        },
        assessmentFactor.contributionComponents);
      },
      maturityDomain.assessmentFactors);
    },
    vm.maturityProfile.maturityDomains);

    $q.all([
      dfdSetLevelControls.promise,
    ]).then(dfdSetInputs.resolve);

    return dfdSetInputs.promise;
  }

  function _recalculateLevelControlCounts(componentLevel) {
    let selectedLevelControlCount = 0;
    R.forEach(
      (levelControl) => {
        if (levelControl.isSelected) {
          selectedLevelControlCount += 1;
        }
      },
      componentLevel.levelControls
    );
    componentLevel.selectedLevelControlsCount = selectedLevelControlCount;
  }

  function _performSave() {
    const dfdSaveMaturityAssessment = $q.defer();
    const maturities = _getSelectedComponentLevelControlsFromDialog();

    return ecatDataService.saveBulkMaturityAssessment(vm.assessmentId, maturities).then(() => {
      $rootScope.$broadcast('refreshECATMaturityProfile', { assessmentId: vm.assessmentId });

      if (vm.saveType === 'saveAndClose') {
        _closeDialog();
      }

      dfdSaveMaturityAssessment.resolve();
    });
  }

  function _getSelectedComponentLevelControlsFromDialog() {
    const selectedComponentLevels = [];
    R.forEach((maturityDomain) => {
      R.forEach((assessmentFactor) => {
        R.forEach((contributionComponent) => {
          R.forEach((componentLevel) => {
            const currentComponentLevel = {
              componentLevelId: componentLevel.componentLevelId,
              note: componentLevel.note,
              selectedLevelControls: [],
              actionPlanLevelControls: [],
              levelControlNotes: [],
            };

            R.forEach((levelControl) => {
              if (levelControl.controlMaturityAssessment.selected) {
                currentComponentLevel.selectedLevelControls.push(levelControl.controlMaturityAssessment.levelControlId);
              }

              if (levelControl.controlMaturityAssessment.includeInActionPlan) {
                currentComponentLevel.actionPlanLevelControls.push(levelControl.controlMaturityAssessment.levelControlId);
              }

              if (levelControl.controlMaturityAssessment.notes !== null) {
                const entry = `${levelControl.levelControlId}_${levelControl.controlMaturityAssessment.notes}`;
                currentComponentLevel.levelControlNotes.push(entry);
              }
            },
            componentLevel.levelControls);

            selectedComponentLevels.push(currentComponentLevel);
          },
          contributionComponent.componentLevels);
        },
        assessmentFactor.contributionComponents);
      },
      maturityDomain.assessmentFactors);
    },
    vm.maturityProfile.maturityDomains);

    return selectedComponentLevels;
  }

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.ecat.editMaturityProfileDialog);
  }
}

EditMaturityProfileDialogController.$inject = [
  '$filter',
  '$q',
  '$rootScope',
  '$scope',

  'alerts',
  'confirmCompleteAssessmentDialog',
  'ecatDataService',
  'ecatSharedModelService',
  'loaderService',
  'ssDialogService'
];
